module.exports = __webpack_public_path__ + "media/images/features/refund/bg-features-1abb2d2cdf7442391f49310b7b4adf5e.jpg";